import React from 'react';
import { Link } from "react-router-dom";
import { imageBaseUrl } from "../assets/backend";
import { truncateText, generatePath } from "../assets/utils";
import ROUTES from '../../route';

const BookIndex = ({ book }) => {
    const bookPath = generatePath(ROUTES.BOOK_SHOW, { id: book.id });
    const progression = book.pivot?.progression ?? 0;

    return (
        <div className="bg-white rounded-xl border border-warm-100 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col h-full">
            <Link to={{ pathname: bookPath }} className="flex flex-col flex-grow">
                <div className="relative w-full h-52 bg-warm-100 overflow-hidden">
                    {book.picture ? (
                        <img
                            src={`${imageBaseUrl}/${book.picture}`}
                            alt={`${book.title} cover`}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center">
                            <span className="text-5xl opacity-40">📖</span>
                        </div>
                    )}
                </div>

                <div className="p-4 flex flex-col flex-grow">
                    <h3 className="font-serif font-bold text-warm-800 text-lg leading-snug mb-1">
                        {book.title}
                    </h3>
                    <p className="text-warm-400 text-sm mb-3">{book.author?.name}</p>

                    {book.genres?.length > 0 && (
                        <div className="flex flex-wrap gap-1 mb-3">
                            {book.genres.slice(0, 2).map((genre, i) => (
                                <span key={i} className="bg-warm-100 text-warm-600 text-xs px-2 py-0.5 rounded-full">
                                    {genre.name}
                                </span>
                            ))}
                        </div>
                    )}

                    {book.description && (
                        <p className="text-warm-500 text-sm leading-relaxed flex-grow">
                            {truncateText(book.description.replace(/<[^>]*>/g, ''), 150)}
                        </p>
                    )}
                </div>
            </Link>

            <div className="px-4 pb-4">
                <div className="flex items-center gap-2">
                    <div className="flex-1 bg-warm-100 rounded-full h-1.5">
                        <div
                            className="bg-amber-500 h-1.5 rounded-full transition-all duration-300"
                            style={{ width: `${progression}%` }}
                        />
                    </div>
                    <span className="text-warm-400 text-xs w-8 text-right">{progression}%</span>
                </div>
            </div>
        </div>
    );
};

export default BookIndex;
